import i18next from 'i18next'
import * as React from 'react'
import { Link, Updater, Widget, fromJSX } from 'widgets-for-react'
import { routeUpdaters } from '../../site/root/routes/routesState'
import {
  AuthButtonPrimary,
  FormControls,
  FormNotification,
  FormSkeletonLayout,
  formSkeletonConfig,
} from '../../utils/forms'
import { AuthState, SignUpState, isSignUpState } from './authState'
import { getClassName, options } from './utils'

export function signup_promo_code_form(
  options: options,
  s0: SignUpState,
  readonly: boolean
): Widget<Updater<AuthState>> {
  return fromJSX((setState: (_: Updater<AuthState>) => void) => (
    <FormSkeletonLayout
      type="sign-up"
      kind="text-image"
      onSubmit={(e) => {
        e.preventDefault()
        setState((s) =>
          isSignUpState(s) ? { ...s, signUpState: 'sign up - signing up' } : s
        )
      }}
      options={options}
      isClrInverted={true}
      image={formSkeletonConfig.imageDark}
    >
      <header className={getClassName(options, 'headerClassName', 'mb-4')}>
        <h1 className={getClassName(options, 'titleClassName', 'mb-4')}>
          {i18next.t('promoCode:step2Title')}
        </h1>
        <p className={getClassName(options, 'introClassName', 'lead')}>
          {i18next.t('promoCode:step2Intro')}
        </p>
      </header>

      {/* Notification */}
      {s0.signUpState === 'sign up - error invalid promo code' && (
        <FormNotification
          options={options}
          message={
            <>
              {i18next.t('promoCode:codeInvalidErrorPre')}{' '}
              <Link to={routeUpdaters(i18next.language).register.url}>
                {i18next.t('promoCode:codeInvalidErrorPage')}
              </Link>{' '}
              {i18next.t('promoCode:codeInvalidErrorPost')}
            </>
          }
        />
      )}

      {/* Promo Code */}
      <FormControls.FormItemInGroup
        controlId="promoCode"
        label={i18next.t('promoCode:code')}
        type="text"
        required={true}
        value={s0.login_data.promoCode || ''}
        readOnly={readonly}
        onChange={(newValue) =>
          setState((s) =>
            isSignUpState(s)
              ? {
                  ...s,
                  login_data: {
                    ...s.login_data,
                    promoCode: newValue,
                  },
                }
              : s
          )
        }
      />

      {/* Submit */}
      <div className={getClassName(options, 'formActionsClassName', '')}>
        <div className={getClassName(options, 'clickableWrapperClassName', '')}>
          <AuthButtonPrimary
            kind="button"
            type="submit"
            disabled={!s0.login_data.promoCode}
            label={
              readonly ? (
                <FormControls.SubmittingSpinner />
              ) : (
                i18next.t('auth:signupSubmit')
              )
            }
            onClick={() => null}
          />
        </div>
      </div>
    </FormSkeletonLayout>
  ))
}
